/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { CvSearchSyncStatusResponseDto } from '../models';
/**
 * CvSearchSyncStatusRestApi - axios parameter creator
 */
export const CvSearchSyncStatusRestApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Latest stored snapshot with health evaluated at read time. Admin only.
         * @summary Get latest KnowMe vs CV Search synchronization status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCvSearchSyncStatus: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/statistics/cv-search-sync-status`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Read-only for both systems - it only recalculates and stores the snapshot. Admin only.
         * @summary Compute a fresh synchronization status snapshot now
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        recomputeCvSearchSyncStatus: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/statistics/cv-search-sync-status/recompute`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CvSearchSyncStatusRestApi - functional programming interface
 */
export const CvSearchSyncStatusRestApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CvSearchSyncStatusRestApiAxiosParamCreator(configuration)
    return {
        /**
         * Latest stored snapshot with health evaluated at read time. Admin only.
         * @summary Get latest KnowMe vs CV Search synchronization status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCvSearchSyncStatus(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CvSearchSyncStatusResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCvSearchSyncStatus(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CvSearchSyncStatusRestApi.getCvSearchSyncStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Read-only for both systems - it only recalculates and stores the snapshot. Admin only.
         * @summary Compute a fresh synchronization status snapshot now
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async recomputeCvSearchSyncStatus(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CvSearchSyncStatusResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.recomputeCvSearchSyncStatus(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CvSearchSyncStatusRestApi.recomputeCvSearchSyncStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CvSearchSyncStatusRestApi - factory interface
 */
export const CvSearchSyncStatusRestApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CvSearchSyncStatusRestApiFp(configuration)
    return {
        /**
         * Latest stored snapshot with health evaluated at read time. Admin only.
         * @summary Get latest KnowMe vs CV Search synchronization status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCvSearchSyncStatus(options?: RawAxiosRequestConfig): AxiosPromise<CvSearchSyncStatusResponseDto> {
            return localVarFp.getCvSearchSyncStatus(options).then((request) => request(axios, basePath));
        },
        /**
         * Read-only for both systems - it only recalculates and stores the snapshot. Admin only.
         * @summary Compute a fresh synchronization status snapshot now
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        recomputeCvSearchSyncStatus(options?: RawAxiosRequestConfig): AxiosPromise<CvSearchSyncStatusResponseDto> {
            return localVarFp.recomputeCvSearchSyncStatus(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CvSearchSyncStatusRestApi - interface
 */
export interface CvSearchSyncStatusRestApiInterface {
    /**
     * Latest stored snapshot with health evaluated at read time. Admin only.
     * @summary Get latest KnowMe vs CV Search synchronization status
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCvSearchSyncStatus(options?: RawAxiosRequestConfig): AxiosPromise<CvSearchSyncStatusResponseDto>;

    /**
     * Read-only for both systems - it only recalculates and stores the snapshot. Admin only.
     * @summary Compute a fresh synchronization status snapshot now
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    recomputeCvSearchSyncStatus(options?: RawAxiosRequestConfig): AxiosPromise<CvSearchSyncStatusResponseDto>;

}

/**
 * CvSearchSyncStatusRestApi - object-oriented interface
 */
export class CvSearchSyncStatusRestApi extends BaseAPI implements CvSearchSyncStatusRestApiInterface {
    /**
     * Latest stored snapshot with health evaluated at read time. Admin only.
     * @summary Get latest KnowMe vs CV Search synchronization status
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getCvSearchSyncStatus(options?: RawAxiosRequestConfig) {
        return CvSearchSyncStatusRestApiFp(this.configuration).getCvSearchSyncStatus(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Read-only for both systems - it only recalculates and stores the snapshot. Admin only.
     * @summary Compute a fresh synchronization status snapshot now
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public recomputeCvSearchSyncStatus(options?: RawAxiosRequestConfig) {
        return CvSearchSyncStatusRestApiFp(this.configuration).recomputeCvSearchSyncStatus(options).then((request) => request(this.axios, this.basePath));
    }
}

